const getModuleState = (state) => state.login;

export const getLoginInfo = (state) => getModuleState(state).loginInfo;